"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _Badge = _interopRequireDefault(require("@mui/material/Badge"));
var _styles = _interopRequireDefault(require("../styles"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "badgeContent", "maxvalue", "variant"];
var styles = function styles(theme) {
  return {
    badge: {
      color: theme.palette.grey[200],
      background: theme.palette.status.error.fill,
      top: '-0.02rem',
      right: '0.05rem',
      width: 'auto',
      fontSize: theme.typography.caption.fontSize,
      borderRadius: _tokens.borderRadiusLarge,
      padding: "0 " + _tokens.spacing20,
      border: _tokens.borderWidthThin + " solid " + theme.palette.grey[200]
    },
    dot: {
      height: '0.625rem',
      width: '0.625rem',
      display: 'inline-block',
      minWidth: 'auto',
      padding: 0
    }
  };
};

/**
 * Use a `NotificationBadge` to indicate a new notification, change, or update.
 */
var NotificationBadge = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    badgeContent = props.badgeContent,
    maxvalue = props.maxvalue,
    variant = props.variant,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = (0, _extends2.default)({
    badge: classes.badge,
    dot: classes.dot
  }, classes);
  return /*#__PURE__*/_react.default.createElement(_Badge.default, (0, _extends2.default)({}, rest, {
    badgeContent: badgeContent || ' ',
    classes: classOverrides,
    invisible: false,
    max: maxvalue,
    variant: variant,
    ref: ref,
    overlap: "rectangular" // this addresses a bug in MUI, where the internal default value ("rectangle") is deprecated
  }));
});

NotificationBadge.muiName = 'NotificationBadge';
NotificationBadge.displayName = 'NotificationBadge';
NotificationBadge.propTypes = {
  /**
   * @ignore
   *
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
  */
  anchorOrigin: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOf(['left', 'right']).isRequired,
    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: _propTypes.default.number,
  /**
   * The badge will be added relative to this node.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   *
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes.default.elementType,
  /**
   * Max value of content rendered within the badge.
   */
  maxvalue: _propTypes.default.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * Variant of the badge
   */
  variant: _propTypes.default.oneOf(['dot', 'standard'])
};
NotificationBadge.defaultProps = {
  maxvalue: 999,
  variant: 'standard'
};
var _default = (0, _styles.default)(styles)(NotificationBadge);
exports.default = _default;